<div [ngClass]="class" class="db-ai-builder-demo-banner">
  <div class="db-ai-builder-demo-banner__features">
    <h1 [innerHTML]="title" class="db-ai-builder-demo-banner__title"></h1>
    <p *ngFor="let feature of features" class="db-ai-builder-demo-banner__item">
      <i class="db-icon db-icon-ds-checkmark"></i>
      <span [innerHTML]="feature"></span>
    </p>
    <div>
      <a class="ds-btn-blue ds-btn-l" (click)="openCheckoutDialog()">
        @if (!!campaignInfo) {
          <span> Try 10Web Pro for {{ campaignInfo?.couponDays == 30 ?
            '1 Month' : campaignInfo?.couponDays + ' Days'
            }}
    <ng-container *ngIf="campaignInfo?.couponPercent"> + {{campaignInfo?.couponPercent}}% off</ng-container>  </span>
        } @else {
          <span [innerHTML]="'text_informativeBtnText' | dbText | lowerCaseSpecificWords"></span>
        }
      </a>
    </div>
  </div>
  <div class="db-ai-builder-demo-banner__img">
    <img src="assets/images/backgrounds/ai-builder-demo-banner.jpg" alt=""/>
  </div>
</div>
